<ion-header translucent>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="inner-content">
  <section class="offer-container-skeleton flex-column justify-center align-center" *ngIf="!imageLoaded">
    <ion-thumbnail class="offer-image">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-thumbnail>
    <ion-skeleton-text animated class="offer-title"></ion-skeleton-text>
    <ion-skeleton-text animated class="offer-sub-title"></ion-skeleton-text>
  </section>
  <section class="offer-container">
    <div *ngFor="let offer of offers; let i = index">
      <ion-card>
        <img class="preview-img" src="{{offer.image}}" alt="Image-{{offer.heading}}" (load)="this.imageLoaded = true"
             [class.imageLoaded]="imageLoaded" class="image">
        <ion-card-header>
          <ion-card-title class="preview-title" [innerHTML]="offer.heading"></ion-card-title>
          <ion-card-subtitle class="preview-subtitle" [innerHTML]="offer.text"></ion-card-subtitle>
        </ion-card-header>
      </ion-card>
    </div>
  </section>
</div>
